export function findPageName(list = []) {
  const pageList = list && list.length > 0 && list.map((pageListItem) => pageListItem.fields.code);
  // const pageName = list && list.find((item) => item.fields.code).fields.code;

  return pageList;
}
